<div *ngIf="!hidden" style="position:absolute;left: calc(50% - 15px); top: 5px;" [class.margin-top]="offsetTop">
    <mat-progress-spinner
        color="primary"
        diameter="30"
        [mode]="mode"
        [value]="value">
    </mat-progress-spinner>
</div>